import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useUser } from '#/contexts/UserEnvironmentContext';
import { fetchNotifications } from '#/zustand-stores/userNoficationsStore';

export function FetchNotificationsOnPageChangeGlobalHandler() {
  const location = useLocation();

  const { user } = useUser();

  // Fetch notifications on each location change
  useEffect(() => {
    if (user?.hasNotifications) void fetchNotifications();
  }, [location.pathname, user?.hasNotifications]);

  return null;
}
